import ResellerAPI from 'dashboard/api/reseller';

export const state = {
  subAccounts: [],
  profile: null,
  wholesale: null,
  commissions: null,
  withdrawals: { available: 0, withdrawals: [] },
  overview: null,
  plans: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getSubAccounts($state) {
    return $state.subAccounts;
  },
  getProfile($state) {
    return $state.profile;
  },
  getWholesale($state) {
    return $state.wholesale;
  },
  getCommissions($state) {
    return $state.commissions;
  },
  getWithdrawals($state) {
    return $state.withdrawals;
  },
  getOverview($state) {
    return $state.overview;
  },
  getPlans($state) {
    return $state.plans;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit('setUIFlag', { isFetching: true });
    try {
      const { data } = await ResellerAPI.get();
      commit('setSubAccounts', data.payload);
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },
  async getProfile({ commit }) {
    const { data } = await ResellerAPI.getProfile();
    commit('setProfile', data);
  },
  async updateProfile({ commit }, formData) {
    const { data } = await ResellerAPI.updateProfile(formData);
    commit('setProfile', data);
    return data;
  },
  async updateAmbassador({ commit }, whatsapp) {
    const { data } = await ResellerAPI.updateAmbassador(whatsapp);
    commit('setProfile', data);
    return data;
  },
  async resetProfile({ commit }) {
    const { data } = await ResellerAPI.resetProfile();
    commit('setProfile', data);
    return data;
  },
  async getWholesale({ commit }) {
    const { data } = await ResellerAPI.getWholesale();
    commit('setWholesale', data);
    return data;
  },
  async getCommissions({ commit }) {
    const { data } = await ResellerAPI.getCommissions();
    commit('setCommissions', data);
    return data;
  },
  async getWithdrawals({ commit }) {
    const { data } = await ResellerAPI.getWithdrawals();
    commit('setWithdrawals', data);
    return data;
  },
  async createWithdrawal({ dispatch }, payload) {
    const { data } = await ResellerAPI.createWithdrawal(payload);
    await dispatch('getWithdrawals');
    return data;
  },
  async getOverview({ commit }) {
    const { data } = await ResellerAPI.getOverview();
    commit('setOverview', data);
    return data;
  },
  async create({ commit }, payload) {
    commit('setUIFlag', { isCreating: true });
    try {
      const { data } = await ResellerAPI.create({ sub_account: payload });
      return data;
    } finally {
      commit('setUIFlag', { isCreating: false });
    }
  },
  async promoteSubAccount({ dispatch }, { id, partnerType = 'reseller' }) {
    const { data } = await ResellerAPI.promoteSubAccount(id, partnerType);
    await dispatch('get');
    return data;
  },
  async setSubscription(
    { dispatch },
    { id, amount, billingType, resellerPlanId }
  ) {
    const { data } = await ResellerAPI.setSubscription(id, {
      amount,
      billingType,
      resellerPlanId,
    });
    await dispatch('get');
    return data;
  },
  async getPlans({ commit }) {
    const { data } = await ResellerAPI.getPlans();
    commit('setPlans', data);
    return data;
  },
  async createPlan({ dispatch }, plan) {
    const { data } = await ResellerAPI.createPlan(plan);
    await dispatch('getPlans');
    return data;
  },
  async updatePlan({ dispatch }, { id, ...plan }) {
    const { data } = await ResellerAPI.updatePlan(id, plan);
    await dispatch('getPlans');
    return data;
  },
  async deletePlan({ dispatch }, id) {
    await ResellerAPI.deletePlan(id);
    await dispatch('getPlans');
  },
  async cancelSubscription({ dispatch }, { id }) {
    const { data } = await ResellerAPI.cancelSubscription(id);
    await dispatch('get');
    return data;
  },
};

export const mutations = {
  setSubAccounts($state, payload) {
    $state.subAccounts = payload;
  },
  setProfile($state, profile) {
    $state.profile = profile;
  },
  setWholesale($state, data) {
    $state.wholesale = data;
  },
  setCommissions($state, data) {
    $state.commissions = data;
  },
  setWithdrawals($state, data) {
    if (data) $state.withdrawals = data;
  },
  setOverview($state, data) {
    $state.overview = data;
  },
  setPlans($state, plans) {
    $state.plans = plans;
  },
  setUIFlag($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
